import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function Testimonials() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section id="testimonios" className="w-full bg-white py-20 px-4" data-id="element-167">
      <div className="max-w-7xl mx-auto" data-id="element-168">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-169">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-170">
            O que dizem os professores que já usam
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-171">
          <motion.div variants={itemVariants} className="bg-gray-50 rounded-xl p-8 hover:shadow-lg transition-shadow duration-300" data-id="element-172">
            <div className="flex items-center mb-6" data-id="element-173">
              <div className="w-14 h-14 rounded-full bg-red-700 flex items-center justify-center text-white text-xl font-bold" data-id="element-174">
                A
              </div>
              <div className="ml-4" data-id="element-175">
                <h3 className="font-bold text-gray-900" data-id="element-176">Ana Paula M.</h3>
                <p className="text-sm text-gray-600" data-id="element-177">
                  Professora de Artes — Rede Municipal, SP
                </p>
              </div>
            </div>

            <p className="text-gray-700 leading-relaxed italic" data-id="element-178">
              "Material incrível! Os planos de aula do Fundamental I me salvaram
              o ano. Meus alunos adoraram a unidade de Arte Urbana. Recomendo
              demais!"
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-gray-50 rounded-xl p-8 hover:shadow-lg transition-shadow duration-300" data-id="element-179">
            <div className="flex items-center mb-6" data-id="element-180">
              <div className="w-14 h-14 rounded-full bg-red-700 flex items-center justify-center text-white text-xl font-bold" data-id="element-181">
                C
              </div>
              <div className="ml-4" data-id="element-182">
                <h3 className="font-bold text-gray-900" data-id="element-183">Carla S.</h3>
                <p className="text-sm text-gray-600" data-id="element-184">
                  Professora de Artes — Escola Particular, RJ
                </p>
              </div>
            </div>

            <p className="text-gray-700 leading-relaxed italic" data-id="element-185">
              "O bônus de avaliação é ouro puro. Finalmente consigo dar nota em
              Artes sem me sentir injusta. As rubricas são muito claras e
              práticas."
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-gray-50 rounded-xl p-8 hover:shadow-lg transition-shadow duration-300" data-id="element-186">
            <div className="flex items-center mb-6" data-id="element-187">
              <div className="w-14 h-14 rounded-full bg-red-700 flex items-center justify-center text-white text-xl font-bold" data-id="element-188">
                R
              </div>
              <div className="ml-4" data-id="element-189">
                <h3 className="font-bold text-gray-900" data-id="element-190">Rodrigo T.</h3>
                <p className="text-sm text-gray-600" data-id="element-191">
                  Professor Polivalente — Anos Iniciais, MG
                </p>
              </div>
            </div>

            <p className="text-gray-700 leading-relaxed italic" data-id="element-192">
              "Eu não sou especialista em Artes, mas com esse material consigo
              dar aulas lindas e bem fundamentadas. O guia de materiais
              econômicos é genial."
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}